export function MobileSegmentedControl({ items, value, onChange, compact = false }: { items: [string, string][]; value: string; onChange: (value: string) => void; compact?: boolean }) {
  return (
    <div className={`mobile-segmented ${compact ? 'compact' : ''}`} role="tablist">
      {items.map(([id, label]) => (
        <button type="button" role="tab" aria-selected={value === id} className={value === id ? 'active' : ''} key={id} onClick={() => onChange(id)}>
          {label}
        </button>
      ))}
    </div>
  );
}
